import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

interface LayoutProps {
  children: React.ReactNode;
  hideFooter?: boolean;
}

const Layout: React.FC<LayoutProps> = ({ children, hideFooter }) => (
  <>
    <Navbar />
    <main style={{ paddingTop: '64px' }}>{children}</main>
    {!hideFooter && <Footer />}
  </>
);

export default Layout;
